// ⚠️  GENERATED — do not edit. Run `npm run inferrex:generate` to regenerate.
/**
 * @inferrex/sdk — Notifications resource client
 * Generated from route definitions in services/api/route-definitions.ts
 */

import type { HttpClient, RequestOptions } from '../http.js';

export class NotificationsClient {
  constructor(private readonly http: HttpClient) {}

  /** List Notifications via the Inferrex API. */
  async listNotifications(options?: { page?: number | undefined; pageSize?: number | undefined }): Promise<{ notifications: { id: string; type: string; title: string; body: string; resourceType: string | null; resourceId: string | null; readAt: string | null; createdAt: string }[]; pagination: { page: number; pageSize: number; total: number; totalPages: number } }> {
    return this.http.get<{ notifications: { id: string; type: string; title: string; body: string; resourceType: string | null; resourceId: string | null; readAt: string | null; createdAt: string }[]; pagination: { page: number; pageSize: number; total: number; totalPages: number } }>('/v1/notifications', options);
  }

  /** Get Unread Notification Count via the Inferrex API. */
  async getUnreadNotificationCount(): Promise<{ unreadCount: number }> {
    return this.http.get<{ unreadCount: number }>('/v1/notifications/unread-count');
  }

  /** Mark Notification Read via the Inferrex API. */
  async markNotificationRead(id: string, requestOptions?: RequestOptions): Promise<{ success: boolean }> {
    return this.http.post<{ success: boolean }>(`/v1/notifications/${id}/read`, undefined, requestOptions);
  }

  /** Mark All Notifications Read via the Inferrex API. */
  async markAllNotificationsRead(requestOptions?: RequestOptions): Promise<{ markedCount: number }> {
    return this.http.post<{ markedCount: number }>('/v1/notifications/read-all', undefined, requestOptions);
  }

  /** Set Channel Credential via the Inferrex API. */
  async setChannelCredential(id: string, request: { secret: string; config?: Record<string, unknown> | null }, requestOptions?: RequestOptions): Promise<{ id: string; ok: boolean }> {
    return this.http.post<{ id: string; ok: boolean }>(`/v1/workspace/notification-channels/${id}/credential`, request, requestOptions);
  }

  /** Verify Channel via the Inferrex API. */
  async verifyChannel(id: string, requestOptions?: RequestOptions): Promise<{ id: string; verified: boolean }> {
    return this.http.post<{ id: string; verified: boolean }>(`/v1/workspace/notification-channels/${id}/verify`, undefined, requestOptions);
  }
}
